import { styled } from '@mui/material/styles';
import DialogContent from '@mui/material/DialogContent';

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  background: `${theme.palette.base.white} !important`,
  backgroundColor: `${theme.palette.base.white} !important`,
}));

export const modalActionButtonStyles = {
  height: '32px',
  fontSize: '16px',
};
